import React from 'react'
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import StudentController from "../../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import TableHeader from "../../../../../components/TableHeader";
import FeeStudentController from "../../../../../services/system/fee-student/fee-student-controller";
import Utils from "../../../../../utils/utils";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()} />;
}
class DetailFeeStudentManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listClassRoom: [],
            discountAdmissionsList: [],
            discountSpecialList: [],
            feeStartYearList: [],
            feeList: [],
            feeServiceList: [],
            totalFeeStartYear: null,
            totalMonthSemester: 0,
            totalMonthYear: 0,
            totalMoneyMonth: 0,
            totalMoneySemester: 0,
            totalMoneyYear: 0,
            totalFeeItem: 0,
            totalFeeAfterDiscountTs: 0,
            totalFeeLastAfterDiscount: [0],
            totalDiscountTs: 0,
            listBuaAn: [],
            allClass: [],
            allGrade: [],
            showInfo: [],
            gradeId: -1,

            listRegister: [],

            month: 0,
            content: "",
            pageNumber: 0,
            pageSize: 10,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Hạng mục",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "month",
                    name: "Số tiền/Tháng",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "ky",
                    name: "Đóng theo kỳ",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "year",
                    name: "Đóng theo năm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Ghi chú",
                    style: {textAlign: "left"},
                    sort: false
                }
            ],
        };
    }

    componentWillMount() {
        const [searchparams] = this.props.params;
        let feeId = searchparams.get("feeId");
        let studentId = searchparams.get("studentId");
        this.setState({
            feeId: feeId,
            studentId: studentId,

        }, ()=>{
            this.getDetailFeeStudent()
        })

    }
    getViewDetailFeeStudent() {
        let payload = {
            studentId: this.state.studentId,
            feeId: parseInt(this.state.feeId),
            yearId: parseInt(getSchoolYear())
        };
        FeeStudentController.viewDetailFeeStudent(payload, res => {
            if (res.success){
                this.setState(res.data)
            }
        })
    }
    getDetailFeeStudent() {
        let payload = {
            studentId: this.state.studentId
        };
        FeeStudentController.detailFeeStudent(payload, res => {
            if (res.success){
                this.setState(res.data)
            }
        })
    }
    getDiscountSpecial() {
        let posDiscountSpecial = this.state.feeStartYearList.length+1;
        if (this.state.feeList.length < 1){
            return <tbody>
            <td style={{textAlign: "center"}} scope="row">
            </td>
            <td style={{textAlign: "center"}} scope="row">
                Không có ưu đãi đặc biệt
            </td>
            </tbody>
        }
        return this.state.feeList.map((item, index) =>
            <tbody>
            <tr style={{height: 50}}>
                <td style={{textAlign: "center"}} scope="row">
                    {posDiscountSpecial+index}
                </td>
                <td style={{textAlign: "left"}} scope="row">
                    {index > 1? index%2===0? <b>{item.name}</b>:<span>{item.name}</span>:<span>{item.name}</span>}
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price)}
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price*this.state.totalMonthSemester)}
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price*this.state.totalMonthYear)}
                </td>
                <td style={{textAlign: "left"}} scope="row">
                    {item.note}
                </td>
            </tr>
            </tbody>
        )
    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: parseInt(this.state.classRoomId),
            grade: this.state.gradeId,
            fullName: this.state.studentName,
            code: "",
            ethnic: "",
            gender: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };

    renderFeeItemFirstYear = () => {
        if (this.state.feeStartYearList.length < 1){
            return <tr style={{height: 50}}>
                <td style={{textAlign: "center"}} scope="row">
                    {""}
                </td>
                <td style={{textAlign: "left"}} scope="row">
                    Không có khoản phí phải đóng
                </td>
                <td style={{textAlign: "center"}} scope="row">
                </td>
                <td style={{textAlign: "center"}} scope="row">
                </td>
                <td style={{textAlign: "center"}} scope="row">
                </td>
                <td style={{textAlign: "left"}} scope="row">
                </td>
            </tr>
        }
        return this.state.feeStartYearList.map((item, index) => <tr style={{height: 50}}>
                <td style={{textAlign: "center"}} scope="row">
                    {index+1}
                </td>
                <td style={{textAlign: "left"}} scope="row">
                    {item.name}
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price)} VNĐ
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price*this.state.totalMonthSemester)} VNĐ
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price*this.state.totalMonthYear)} VNĐ
                </td>
                <td style={{textAlign: "left"}} scope="row">
                </td>
            </tr>
        )
    }
    renderDiscountSpecial = () => {
        if (this.state.discountSpecialList.length < 1){
            return <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                <label className="col-4 label-item pl-0"></label>
                <label className="col-6 label-item pl-0">Học sinh không có ưu đãi đặc biệt</label>
                <label className="col-2 label-item pl-0"><b style={{color: "red",}}>0%</b></label>
            </div>
        }
        return this.state.discountSpecialList.map((item, index) =>
            <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                <label className="col-1 label-item pl-0">{index+1}.</label>
                <label className="col-9 label-item pl-0">{item.name}</label>
                <label className="col-2 label-item pl-0"><b style={{color: "red",}}>{item.discount}%</b>({this.getCharacter(index)})</label>
            </div>
        )
    };
    renderLiveEat = () => {
        if (this.state.feeServiceList.length < 1){
            return <tr style={{height: 50}}>
                <td style={{textAlign: "center"}} scope="row">
                    {""}
                </td>
                <td style={{textAlign: "left"}} scope="row">
                </td>
                <td style={{textAlign: "center"}} scope="row">
                </td>
                <td style={{textAlign: "center"}} scope="row">
                </td>
                <td style={{textAlign: "center"}} scope="row">
                </td>
                <td style={{textAlign: "left"}} scope="row">
                </td>
            </tr>
        }
        return this.state.feeServiceList.map((item, index) =>
            <tr style={{height: 50}}>
                <td style={{textAlign: "center"}} scope="row">
                    {item.stt}
                </td>
                <td style={{textAlign: "left"}} scope="row">
                    {item.name}
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price)} VNĐ
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price*this.state.totalMonthSemester)} VNĐ
                </td>
                <td style={{textAlign: "right"}} scope="row">
                    {Utils.formatMoney(item.price*this.state.totalMonthYear)} VNĐ
                </td>
                <td style={{textAlign: "left"}} scope="row">
                </td>
            </tr>
        )
    };
    getCharacter(index){
        let listCharacter = [ "b", "c", "d", "e", "f", "g", "h" ,"i" ,"k" , "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
        if (index < listCharacter.length)
            return listCharacter[index]
        else
            return index;
    }
    onActive() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            feeId: parseInt(this.state.feeId)
        };
        FeeStudentController.create(payload, res => {
            this.setState({
            });
        })
    }
    render() {
        let {header, gradeId} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-fee" parentClass="wallet-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Chi tiết học phí của học sinh"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Chi tiết học phí của {this.state.studentRes?.fullName}-{this.state.studentRes?.currentClassRoomRes?.name}</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Chi tiết danh mục của học phí
                                            </div>
                                            <div className="col-12 d-flex bg-gradient">
                                                <b>Ưu đãi tuyển sinh</b><hr/>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                                                <label className="col-4 label-item pl-0"></label>
                                                <label className="col-6 label-item pl-0"></label>
                                                <label className="col-3 label-item pl-0"><b>Ưu đãi</b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">{this.state.discountAdmissionsList.length > 0?this.state.discountAdmissionsList[0].name:"Ưu đãi đăng ký"}</label>
                                                <label className="col-5 label-item pl-0"><b>{this.state.discountAdmissionsList.length > 0?this.state.discountAdmissionsList[0].content:""}</b></label>
                                                <label className="col-1 label-item pl-0"></label>
                                                <label className="col-2 label-item pl-0"><b><span  style={{color: "red",}}>{this.state.discountAdmissionsList.length > 0?this.state.discountAdmissionsList[0].discount:"0"}%</span></b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">{this.state.discountAdmissionsList.length > 1?this.state.discountAdmissionsList[1].name:"Ưu đãi đăng ký"}</label>
                                                <label className="col-5 label-item pl-0"><b>{this.state.discountAdmissionsList.length > 1?this.state.discountAdmissionsList[1].content:""}</b></label>
                                                <label className="col-1 label-item pl-0"></label>
                                                <label className="col-2 label-item pl-0"><b><span  style={{color: "red",}}>{this.state.discountAdmissionsList.length >1?this.state.discountAdmissionsList[1].discount:"0"}%</span></b></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                                                <label className="col-4 label-item pl-0"></label>
                                                <label className="col-6 label-item pl-0"><b><span  style={{color: "red",}}>{this.state.discountAdmissionsList.length > 2?this.state.discountAdmissionsList[2].content:""}</span></b></label>
                                                <label className="col-2 label-item pl-0"><b><span  style={{color: "red",}}>{this.state.discountAdmissionsList.length >2?this.state.discountAdmissionsList[2].discount:"0"}%</span>{this.state.discountAdmissionsList.length >2?this.state.discountAdmissionsList[2].note:""}</b></label>
                                            </div>
                                            <div className="col-12 d-flex bg-gradient">
                                                <b>Ưu đãi đặc biệt</b><hr/>
                                            </div>
                                            {this.renderDiscountSpecial()}
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Các khoản phí phải đóng
                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                <tbody>
                                                                <tr style={{height: 50}}>
                                                                    <td style={{textAlign: "center"}} scope="row">
                                                                    </td>
                                                                    <td style={{textAlign: "left"}} scope="row">
                                                                        <b>Các khoản phí đầu năm (đóng 01 lần/năm)</b>
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        <b>{Utils.formatMoney(this.state.totalFeeStartYear != null?this.state.totalFeeStartYear.price:0)}</b>
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        <b>{Utils.formatMoney(this.state.totalFeeStartYear != null?this.state.totalFeeStartYear.price*this.state.totalMonthSemester:0)}</b>
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        <b>{Utils.formatMoney(this.state.totalFeeStartYear != null?this.state.totalFeeStartYear.price*this.state.totalMonthYear:0)}</b>
                                                                    </td>
                                                                    <td style={{textAlign: "left"}} scope="row">
                                                                        {this.state.totalFeeStartYear != null?this.state.totalFeeStartYear.note:""}
                                                                    </td>
                                                                </tr>
                                                                {this.renderFeeItemFirstYear()}
                                                                <tr style={{height: 50}}>
                                                                    <td style={{textAlign: "center"}} scope="row">
                                                                    </td>
                                                                    <td style={{textAlign: "left"}} scope="row">
                                                                        <b>Tổng học phí sau giảm trừ</b>
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        <b>{Utils.formatMoney(this.state.totalFeeAfterDiscount != null?this.state.totalFeeAfterDiscount.price:0)}</b>
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        <b>{Utils.formatMoney(this.state.totalFeeAfterDiscount != null?this.state.totalFeeAfterDiscount.price*this.state.totalMonthSemester-this.state.discountPaymentSemester:0)}</b>
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        <b>{Utils.formatMoney(this.state.totalFeeAfterDiscount != null?this.state.totalFeeAfterDiscount.price*this.state.totalMonthYear-this.state.discountPaymentYear:0)}</b>
                                                                    </td>
                                                                    <td style={{textAlign: "left"}} scope="row">
                                                                        {this.state.totalFeeAfterDiscount != null?this.state.totalFeeAfterDiscount.note:""}
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                                {this.getDiscountSpecial()}
                                                                <tbody>
                                                                <tr style={{height: 50}}>
                                                                    <td style={{textAlign: "center"}} scope="row">
                                                                        {this.state.feeList.length+this.state.feeStartYearList.length+1}
                                                                    </td>
                                                                    <td style={{textAlign: "left"}} scope="row">
                                                                        Giảm trừ đóng theo kỳ/năm
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        <b>0</b>
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        {Utils.formatMoney(this.state.discountPaymentSemester)}
                                                                    </td>
                                                                    <td style={{textAlign: "right"}} scope="row">
                                                                        {Utils.formatMoney(this.state.discountPaymentYear)}
                                                                    </td>
                                                                    <td style={{textAlign: "left"}} scope="row">
                                                                    </td>
                                                                </tr>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    <b>Phí chăm sóc bán trú</b>
                                                                </td>
                                                                <td style={{textAlign: "right"}} scope="row">
                                                                    <b>{Utils.formatMoney(this.state.totalFeeService != null?this.state.totalFeeService.price:0)}</b>
                                                                </td>
                                                                <td style={{textAlign: "right"}} scope="row">
                                                                    <b>{Utils.formatMoney(this.state.totalFeeService != null?this.state.totalFeeService.price*this.state.totalMonthSemester-this.state.discountPaymentSemester:0)}</b>
                                                                </td>
                                                                <td style={{textAlign: "right"}} scope="row">
                                                                    <b>{Utils.formatMoney(this.state.totalFeeService != null?this.state.totalFeeService.price*this.state.totalMonthYear-this.state.discountPaymentYear:0)}</b>
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {this.state.totalFeeService != null?this.state.totalFeeService.note:""}
                                                                </td>
                                                                </tbody>
                                                                <tbody>
                                                                {this.renderLiveEat()}
                                                                </tbody>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    <b>Tổng tiền phải đóng</b>
                                                                </td>
                                                                <td style={{textAlign: "right"}} scope="row">
                                                                    <b>{Utils.formatMoney(this.state.totalFeePay != null?this.state.totalFeePay.price:0)}</b>
                                                                </td>
                                                                <td style={{textAlign: "right"}} scope="row">
                                                                    <b>{Utils.formatMoney(this.state.totalFeePay != null?this.state.totalFeePay.price*this.state.totalMonthSemester-this.state.discountPaymentSemester:0)}</b>
                                                                </td>
                                                                <td style={{textAlign: "right"}} scope="row">
                                                                    <b>{Utils.formatMoney(this.state.totalFeePay != null?this.state.totalFeePay.price*this.state.totalMonthYear-this.state.discountPaymentYear:0)}</b>
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {this.state.totalFeePay != null?this.state.totalFeePay.note:""}
                                                                </td>
                                                            </table>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-1s2">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-hoc-phi-hoc-sinh"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(DetailFeeStudentManagement)